import type { MeetingPrivate, MeetingPublic } from '@repo/types/meetings';
import type { UseInfiniteQueryResult } from '@tanstack/react-query';
import type { ReactNode } from 'react';

import { createContext, use } from 'react';

interface MeetingListContextT {
  meetings: MeetingPrivate[] | MeetingPublic[];
  isSuccess: boolean;
  isLoading: boolean;
  isFetching: boolean;
  fetchNextPage?: () => void;
  hasNextPage?: boolean;
}

const MeetingListContext = createContext<MeetingListContextT>({
  meetings: [],
  isSuccess: false,
  isLoading: false,
  isFetching: false,
});

export const useMeetingListContext = () => {
  return use(MeetingListContext);
};

interface MeetingsListProps {
  query: UseInfiniteQueryResult;
  meetings: MeetingPrivate[] | MeetingPublic[];
  children: ReactNode;
  disableInfiniteScroll?: boolean;
}

export default function MeetingsList({ children, meetings, query, disableInfiniteScroll = false }: MeetingsListProps) {
  return (
    <MeetingListContext
      value={{
        meetings,
        isSuccess: query.isSuccess,
        isLoading: query.isLoading,
        isFetching: query.isFetching,
        fetchNextPage: disableInfiniteScroll ? undefined : query.fetchNextPage,
        hasNextPage: disableInfiniteScroll ? false : query.hasNextPage,
      }}
    >
      {children}
    </MeetingListContext>
  );
}
